import { Button, Input, message, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { fmtDateTimeFull } from "@extensions/utils";
import CompanyItem from "./company-item";
import { fmtDate } from "@extensions/convert";

const Companies = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);

  const getData = () => {
    setLoading(true);
    
    const url = searchText 
      ? `company/search?searchText=${encodeURIComponent(searchText)}`
      : `company/search`;
    
    serverFetch(url)
      .then((data) => {
        setLoading(false);
        setItems(data);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = () => {
    getData();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const onRowClick = (record) => {
    setSelectedCompany({
      companyId: record.id,
    });
  };

  const handleCompanyClose = (refresh) => {
    setSelectedCompany(null);
    if (refresh) {
      getData();
    }
  };

  const columns = [
    { dataIndex: "id", title: "#", width: 60 },
    { dataIndex: "name", title: "Название" },
    { dataIndex: "inn", title: "ИНН" },
    { dataIndex: "email", title: "Email" },
    { dataIndex: "phone", title: "Телефон" },
    { dataIndex: "regDateTime", title: "Создана", render: fmtDateTimeFull },
    { dataIndex: "supportFinishDate", title: "Подписка", render: fmtDate },
  ];

  return (
    <div className="page">
      <Space style={{ marginBottom: 16 }}>
        <Input
          placeholder="Поиск компаний..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyPress={handleKeyPress}
          style={{ width: 300 }}
        />
        <Button type="primary" onClick={handleSearch} loading={loading}>
          Поиск
        </Button>
      </Space>
      
      <Table
        columns={columns}
        dataSource={items}
        loading={loading}
        rowKey="id"
        pagination={false}
        size="small"
        onRow={(record) => ({
          onClick: () => onRowClick(record),
          style: { cursor: 'pointer' }
        })}
      />
      
      {selectedCompany && (
        <CompanyItem
          companyId={selectedCompany.companyId}
          onClose={handleCompanyClose}
        />
      )}
    </div>
  );
};

export default Companies;